const OPTIONS = [['newest', 'Newest placed'], ['delivery', 'Delivery time']];

export function OrderSortToggle({ value, onChange }) {
  return (
    <div className="flex items-center border border-[#2A0F3D] font-mono text-[11px] h-9" role="radiogroup" aria-label="Sort orders" data-testid="order-sort-toggle">
      <span className="px-2 text-[#6B8E73] uppercase hidden sm:inline">Sort</span>
      {OPTIONS.map(([k, label]) => (
        <button key={k} type="button" role="radio" aria-checked={value === k} onClick={() => onChange(k)}
          className={`px-2.5 h-full whitespace-nowrap transition-colors ${value === k ? 'bg-[#39FF14] text-[#050003] font-bold' : 'text-[#A3C7A8] hover:text-[#39FF14]'}`}
          data-testid={`order-sort-${k}`}>{label}</button>
      ))}
    </div>
  );
}
